
<div class="dialog-container">
  <div class="title">
    <h1 mat-dialog-title>SMTH Portal</h1>
    <button mat-icon-button class="close-button" (click)="onDismiss();">
      <mat-icon class="close-icon">close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <div class="message">{{data.message}}</div>
  </mat-dialog-content>

  <div class="tools">
  <div *ngIf="data.dialogType=='confirm'; then thenBlock else elseBlock"></div>
  <ng-template #thenBlock>
    <div class="clearfix btn-flex m-4">
      <button type="button" class="btn btn-no" (click)="onDismiss()" [mat-dialog-close]="true">No</button>
      <button type="button" class="btn btn-yes" (click)="onConfirm()" [mat-dialog-close]="true"
        cdkFocusInitial>Yes</button>
    </div>
  </ng-template>
  <ng-template #elseBlock>
    <mat-dialog-actions align="end">
      <button mat-button class="btn btn-default btn-submit" (click)="onConfirm()" tabindex="1" [mat-dialog-close]="true"
        cdkFocusInitial>Done</button>
    </mat-dialog-actions>
  </ng-template>
</div>
</div>
